import stylesheet0 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".details" + shadowSelector + " {white-space: pre-line;column-count: 2;column-gap: var(--sds-g-spacing-6);margin: 0;overflow-wrap: anywhere;}.title" + shadowSelector + " {margin: auto;padding-bottom: var(--sds-g-spacing-4);}@media (max-width: 767px) {.details" + shadowSelector + " {column-count: inherit;}}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];